import { FC } from 'react'

import { Route, Routes } from 'react-router-dom'
import ElevatorRoutes from 'views/pages/Elevators/routes'
import { ElevatorList } from './ElevatorList'
import { ElevatorDetail } from './ElevatorDetail'

const ElevatorPage: FC = () => {
  return (
    <Routes>
      <Route index element={<ElevatorList />} />
      <Route path={ElevatorRoutes.relativeList} element={<ElevatorList />} />
      <Route path={ElevatorRoutes.relativeDetail} element={<ElevatorDetail />} />
    </Routes>
  )
}

export default ElevatorPage
